import React from 'react';
import Kendra from 'aws-sdk/clients/kendra';

import { TextHighlights } from './TextHighlights';
import { isNullOrUndefined } from '../../facets/utils';
import { Box } from '@cloudscape-design/components';

interface ResultTextProps {
    lastUpdated?: Date;
    text: Kendra.TextWithHighlights;
}

export default ({ text }: ResultTextProps) => {
    return (
        <Box>
            <span>
                {isNullOrUndefined(text) ? null : (
                    <span>
                        <TextHighlights textWithHighlights={text} />
                    </span>
                )}
            </span>
        </Box>
    );
};
